import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield, Cookie, Database, UserCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import Logo from '../components/Logo';
import { associationInfo } from '../mock';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-orange-50 to-amber-50">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <Link to="/">
            <Button variant="outline" className="flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              Retour à l'accueil
            </Button>
          </Link>
        </div>
      </nav>

      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="text-center mb-12">
              <Shield className="w-16 h-16 mx-auto mb-6 text-orange-600" />
              <h1 className="text-5xl font-bold mb-4 bg-gradient-to-br from-slate-900 to-orange-800 bg-clip-text text-transparent">
                Politique de Confidentialité
              </h1>
              <p className="text-slate-600">Protection de vos données personnelles</p>
            </div>

            <div className="space-y-6">
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-orange-700">
                    <Database className="w-5 h-5" />
                    Collecte des données
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-slate-700 space-y-3">
                  <p>APELGP collecte les données personnelles suivantes lors de l'adhésion :</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Prénom et nom</li>
                    <li>Adresse email</li>
                    <li>Numéro de téléphone (optionnel)</li>
                    <li>Code de structure partenaire</li>
                  </ul>
                  <p>Ces données sont collectées uniquement dans le cadre de la gestion associative.</p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-orange-700">
                    <UserCheck className="w-5 h-5" />
                    Utilisation des données
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-slate-700 space-y-2">
                  <p>Vos données sont utilisées pour :</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Gestion de votre adhésion à l'association</li>
                    <li>Communication concernant nos événements et activités</li>
                    <li>Envoi de bulletins d'information liés à la vie associative</li>
                    <li>Traitement de vos demandes via le formulaire de contact</li>
                  </ul>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-orange-700">
                    <Shield className="w-5 h-5" />
                    Vos droits (RGPD)
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-slate-700 space-y-3">
                  <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez :</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>D'un droit d'accès à vos données</li>
                    <li>D'un droit de rectification</li>
                    <li>D'un droit d'effacement (droit à l'oubli)</li>
                    <li>D'un droit d'opposition</li>
                    <li>D'un droit à la portabilité des données</li>
                  </ul>
                  <p className="pt-2">Pour exercer ces droits, contactez-nous via notre <a href="/contact" className="text-orange-700 hover:text-orange-600 underline">formulaire de contact</a>.</p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-orange-700">
                    <Cookie className="w-5 h-5" />
                    Cookies
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-slate-700">
                  <p>Ce site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement. Aucun cookie de traçage publicitaire n'est utilisé.</p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-orange-700">
                    <Database className="w-5 h-5" />
                    Conservation des données
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-slate-700">
                  <p>Vos données personnelles sont conservées pendant la durée de votre adhésion et pour une période de 3 ans après la fin de celle-ci, conformément aux obligations légales.</p>
                </CardContent>
              </Card>
            </div>

            <div className="mt-12 text-center">
              <Link to="/">
                <Button size="lg" className="bg-gradient-to-r from-orange-600 to-amber-600 text-white">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Retour à l'accueil
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
